import PropTypes from "prop-types";

const TurnoSecuencia = ({
    turno,
    onClickTurno,
    puedeEliminarse,
    seleccionado,
}) => {
    return (
        <div
            key={turno.id}
            className="turno-secuencia position-relative border d-flex justify-content-center align-items-center"
            style={{
                backgroundColor: turno.color,
            }}
            onClick={onClickTurno}
        >
            <span>{turno.sigla}</span>
            {puedeEliminarse && (
                <div className="position-absolute turno-icono">
                    <i className="icono-eliminar-turno fas fa-times "></i>
                </div>
            )}

            {seleccionado && (
                <div className="position-absolute">
                    <i className="icono-eliminar-turno fas fa-check text-primary"></i>
                </div>
            )}
        </div>
    );
};

TurnoSecuencia.propTypes = {
    turno: PropTypes.object,
    onClickTurno: PropTypes.func,
    puedeEliminarse: PropTypes.bool,
    seleccionado: PropTypes.bool,
};

const SecuenciaTurnos = ({
    secuencia,
    onEliminarTurno = null,
    indiceSeleccionado = null,
    onSeleccionTurno,
}) => {
    return (
        <div className="d-flex justify-content-center secuencia">
            {secuencia.map((turno, indice) => {
                return (
                    <TurnoSecuencia
                        turno={turno}
                        key={`${turno.id}-${indice}`}
                        seleccionado={indice == indiceSeleccionado}
                        puedeEliminarse={onEliminarTurno != null}
                        onClickTurno={() => {
                            if (onEliminarTurno != null) {
                                onEliminarTurno(turno.id, indice);
                            } else {
                                onSeleccionTurno(indice);
                            }
                        }}
                    />
                );
            })}
        </div>
    );
};

SecuenciaTurnos.propTypes = {
    onEliminarTurno: PropTypes.func,
    onSeleccionTurno: PropTypes.func,
    indiceSeleccionado: PropTypes.number,
    secuencia: PropTypes.arrayOf(PropTypes.obj),
};

export default SecuenciaTurnos;
